<template>
  <div class="view-item with-background">
    <b-container>
      <b-row>
        <b-col>
          <Item :car="car" :auction="auction" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Item from "../components/Item";
import utils from "../assets/js/utils";

export default {
  name: "ItemView",
  components: {
    Item
  },
  data() {
    return {
      auction: 0,
      item: "",
      car: {}
    };
  },
  methods: {
    createUpdate: async function(auction, item) {
      this.auction = parseInt(auction);
      this.item = item;
      const car = await utils.loadCars(this, this.item);
      const properties = await utils.loadProperties(this, car.id);
      this.car = utils.getCar(this.item, [car], properties, true);
    }
  },
  created: async function() {
    await this.createUpdate(
      this.$route.params.auction,
      this.$route.params.item
    );
  },
  beforeRouteUpdate: async function(to, from, next) {
    await this.createUpdate(to.params.auction, to.params.item);
    next();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.view-item {
  background-color: $white;
  display: flex;
  flex-direction: column;

  > .container {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    > .row {
      flex: 1 0 auto;
      > .col {
        min-height: 100%;
      }
    }
  }
}
</style>
